import type { DiagramRecord } from "../../utils/types";

export const resolveDiagramRecordIndex = (
  records: DiagramRecord[],
  idParam: number | null,
): number => {
  if (idParam === null) return 0;
  const index = records.findIndex((record) => record.id === idParam);
  return index >= 0 ? index : 0; // stale / invalid id -> first
};
